import { useState } from 'react'
import type { AllianzCompanySearchResult } from '@klear/allianz/schema'
import { trpc, type RouterInputs } from '@klear/ui/lib/trpc'

export type AllianzCompanySearchInput = RouterInputs['allianz']['searchCompanies']

export function useAllianzCompanySearch(): {
  searchCompanies: (input: AllianzCompanySearchInput) => Promise<AllianzCompanySearchResult>
  isPending: boolean
} {
  const utils = trpc.useUtils()
  const [isPending, setIsPending] = useState(false)

  return {
    isPending,
    searchCompanies: async (input) => {
      setIsPending(true)
      try {
        return await utils.allianz.searchCompanies.fetch(input)
      } finally {
        setIsPending(false)
      }
    }
  }
}
